module.exports = __webpack_public_path__ + "static/media/Logo__RoyalCarribean.30015486.svg";